/**
 * Normaliza URLs de imagen para servicios de hosting que devuelven HTML
 * en lugar de la imagen directa cuando se cargan desde un <img src>.
 *
 * Soporta:
 * - Google Drive `/file/d/{id}/view` → endpoint de thumbnail directo
 * - Google Drive `?id={id}` (uc/open) → endpoint de thumbnail directo
 * - Cualquier otro URL: se devuelve tal cual.
 */
export function normalizeImageUrl(
  url: string | null | undefined,
): string | null | undefined {
  if (!url) return url;

  const driveFileMatch = url.match(
    /drive\.google\.com\/file\/d\/([a-zA-Z0-9_-]+)/,
  );
  if (driveFileMatch) {
    return `https://drive.google.com/thumbnail?id=${driveFileMatch[1]}&sz=w2000`;
  }

  const driveIdMatch = url.match(
    /drive\.google\.com\/(?:uc|open|thumbnail)\?[^#]*\bid=([a-zA-Z0-9_-]+)/,
  );
  if (driveIdMatch) {
    return `https://drive.google.com/thumbnail?id=${driveIdMatch[1]}&sz=w2000`;
  }

  return url;
}
